module.exports = __webpack_public_path__ + "8751c2d2ae9cbf262a35c58632befccc.jpg";